module.exports = __webpack_public_path__ + "static/img/ios-code.87f7111.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ios-code.png
// module id = KS13
// module chunks = 1